import classNames from 'classnames';
import React from 'react';

import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import {pathToURL} from 'BenchlingUtil';
import {ContainerSummary} from 'constants/SampleConstants';
import BenchLink from 'link-preview/BenchLink';
import {loadingIndicatorAttrs} from 'notebook/util/ExportInstrumentation';
import {containerEditorURL} from 'samples/ContainerDAO';
import StorableStore from 'samples/StorableStore';

interface BaseContainerLinkProps {
  containerId: string;
  className?: string;
}

interface StorableStoreProps {
  container: ContainerSummary | null;
}

type ContainerLinkProps = BaseContainerLinkProps & StorableStoreProps;

function mapStorableStoreToProps(
  storableStore: typeof StorableStore,
  props: BaseContainerLinkProps
): StorableStoreProps {
  return {container: storableStore.getContainerSummary(props.containerId)};
}

function ContainerLink(props: ContainerLinkProps): JSX.Element {
  if (!props.container) {
    return (
      <span className={classNames('u-faded', 'u-italic', props.className)} {...loadingIndicatorAttrs()}>
        Loading...
      </span>
    );
  }
  return (
    <span className={props.className}>
      <BenchLink href={pathToURL(containerEditorURL(props.container.id))} fileId={props.container.id}>
        {props.container.name}
      </BenchLink>
      <ArchiveRecordLabel item={props.container} />
    </span>
  );
}

export default StorableStore.connect(mapStorableStoreToProps)(ContainerLink);
